import { Dispatch } from 'react-redux';
import { Action } from '../../actions';
import { StoreState } from '../../reducers';
import { MenuModes, MenuItemType } from '../../typings/menu';
import UserAgentUtils from '../../utils/userAgent';
import { viewDriveItem, DriveItemOrigin } from '../DriveItemList/actions';
import { fetchNewDriveItems } from '../DriveItemList/New/actions';
import { getProfileData } from '../ProfilePage/actions';
import { createNotification } from '../NotificationBar/actions';
import { Api } from '../../typings/api';
import DownloadManagerUtils from '../../utils/downloadManager';
import Utils from '../../utils';
import { checkActiveSession } from '../MultiAppAuthentication/actions';

export enum MenuActionKeys {
	REQUEST_OPEN_LEFT_MENU = '@@menuManager/REQUEST_OPEN_LEFT_MENU',
	REQUEST_CLOSE_LEFT_MENU = '@@menuManager/REQUEST_CLOSE_LEFT_MENU',
	SET_MENU_MODES = '@@menuManager/SET_MENU_MODES'
}

export interface RequestOpenAction extends Action {
	type: MenuActionKeys.REQUEST_OPEN_LEFT_MENU;
}

export interface RequestCloseAction extends Action {
	type: MenuActionKeys.REQUEST_CLOSE_LEFT_MENU;
}

export interface SetMenuModesAction extends Action {
	type: MenuActionKeys.SET_MENU_MODES;
	menuModes: MenuModes;
}

export type MenuAction = RequestOpenAction
	| RequestCloseAction
	| SetMenuModesAction;

export const requestOpenLeftSideMenu = () => (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	dispatch({ type: MenuActionKeys.REQUEST_OPEN_LEFT_MENU });
	dispatch(checkActiveSession())
		.then(() => dispatch(fetchNewDriveItems()));


	// to display user info in left menu
	if (Utils.shouldGetProfileData()) {
		const {
			galleryInfos: { config: { clientId } },
		} = getState();
		dispatch(getProfileData(clientId));
	}
};

export const requestCloseLeftSideMenu = () => (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	const { menuManager } = getState();

	if (menuManager.leftMenuIsOpen) {
		dispatch({ type: MenuActionKeys.REQUEST_CLOSE_LEFT_MENU });
	}
};

export const setMenuConfigMode = (screenFormat: string) => (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	const { template } = getState().galleryInfos;
	const menuConfig = template.menu;

	if (menuConfig) {
		const menuFormat = menuConfig[screenFormat] && Object.keys(menuConfig[screenFormat]).length > 0;
		const menuModes = menuConfig[screenFormat] && menuFormat ? menuConfig[screenFormat] : menuConfig.default;

		dispatch({ type: MenuActionKeys.SET_MENU_MODES, menuModes });
	}
};

export const openCustomItem = (type: MenuItemType, target: string) => (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	const { driveList, downloadManager } = getState();
	const isOnline = UserAgentUtils.isOnline();
	const targetId = Utils.getMediaId(target);
	const resolvedTarget = targetId > 0 ? targetId.toString() : target;
	const isDownloaded = DownloadManagerUtils.isItemDownloaded(downloadManager, parseInt(resolvedTarget, 10));
	const isAvailableItem = (type === MenuItemType.Asset || type === MenuItemType.Page) && (isOnline || isDownloaded);
	const isImage = driveList.driveItems[resolvedTarget] && driveList.driveItems[resolvedTarget].type === Api.DriveItemType.Image;

	if (type === MenuItemType.Link && isOnline) {
		window.open(resolvedTarget, '_blank');
	} else if (type === MenuItemType.Folder || isAvailableItem || isImage) {
		dispatch(viewDriveItem(driveList.driveItems[resolvedTarget], DriveItemOrigin.Menu));
	} else {
		dispatch(createNotification('info.offline_download_single_asset'));
		return;
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/actions.ts